// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-wrapper":"_2453W","title":"_3tQLG","right-arrow":"_32pUE","home-icon":"_3lyWY"};